import { compose, withProps } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import { surveyActions } from '../../../redux/surveys/actions';
import { targetUserIdSelector } from '../../../redux/context/selectors';
import * as appointmentConsent from '../../../redux/surveys/appointment-consent-req';
import styles from './index.styl';

const mapStateToProps = state => ({
  targetUserId: targetUserIdSelector(state),
});

const mapDispatchToProps = {
  getAppointmentConsent: appointmentConsent.actions.send,
  linkConsent: surveyActions.linkConsent,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(({ assignmentId, targetUserId, settings, linkConsent }) => {
    return {
      onLink: () =>
        linkConsent({
          settings,
          assignmentId,
          targetUserId,
        }),
    };
  }),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/Question/enhance.js